import { connect, useDispatch } from "react-redux";
import { getRecibosByFilter } from "../../../actions/cuentacorriente";
import { useEffect, useState } from "react";
import { RECIBO_COLUMN } from "./interface/columnData";
import TableCustom from "../../../common/components/table/table";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import IFilterRecibo from "./interface/IFilterRecibo";
import Filter from "./filter";
import cuentaCorrienteService from "../../../services/cuentacorriente";
import IClienteIdFilter from "../../../common/interface/IClienteIdFilter";
import Descarga from "../descarga";

interface IReciboProps {
  recibos?: any;
  error?: any;
  loading?: any;
}

const Recibo = (props: IReciboProps) => {
  const dispatch = useDispatch();
  const localStorage = JSON.parse(
    window.localStorage.getItem("LocalSession") || "{}",
  );
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingPdf, setLoadingPdf] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [filter, setFilter] = useState<IFilterRecibo>({
    clienteId: localStorage.clienteId.trim(),
    dateFrom: null,
    dateTo: null,
    montoDesde: "",
    montoHasta: "",
    page: 0,
    rowPerPage: 5,
    sortField: { field: "fechaEmision", order: "DESC" },
  });
  const [clienteFilter, setClienteFilter] = useState<IClienteIdFilter>({
    clienteId: localStorage.clienteId.trim(),
  });
  const getRecibos = (page: number, rowsPerPage: number): void => {
    setError(false);
    filter.rowPerPage = rowsPerPage;
    filter.page = page;
    dispatch(getRecibosByFilter(filter));
  };
  const getFilterRecibos = (): void => {
    setError(false);
    setPage(0);
    setRowsPerPage(5);
    filter.rowPerPage = 5;
    filter.page = 0;
    dispatch(getRecibosByFilter(filter));
  };
  useEffect(() => {
    dispatch(getRecibosByFilter(filter));
  }, []);

  const clean = (): void => {
    setError(false);
    setPage(0);
    setRowsPerPage(5);
    filter.rowPerPage = 5;
    filter.page = 0;
    filter.dateFrom = null;
    filter.dateTo = null;
    filter.montoDesde = "";
    filter.montoHasta = "";

    dispatch(getRecibosByFilter(filter));
  };

  useEffect(() => {
    console.log(props.recibos);
    // if (props.estadopedidos.data) {
    //     setAcopios(props.acopios?.data.$values);
    // }
  }, [props]);

  const handleSort = (dataKey: string) => {
    const newOrder =
      filter.sortField.field === dataKey && filter.sortField.order === "ASC"
        ? "DESC"
        : "ASC";

    setPage(0);
    const newFilter: IFilterRecibo = {
      ...filter,
      sortField: { field: dataKey, order: newOrder },
      page: 0,
    };
    setFilter(newFilter);
    dispatch(getRecibosByFilter(newFilter));
  };

  const handleDownload = async () => {
    setLoading(true);
    setError(false);
    const filterExcel = clienteFilter;
    filterExcel.dateFrom = filter.dateFrom;
    filterExcel.dateTo = filter.dateTo;
    filterExcel.montoDesde = filter.montoDesde;
    filterExcel.montoHasta = filter.montoHasta;

    const response = await cuentaCorrienteService.downloadFileRecibo(
      filterExcel,
    );
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "recibo.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    setLoading(false);
  };

  const handleDownloadPdf = async (item: any) => {
    setLoadingPdf(true);
    setError(false);
    try {
      const response = await cuentaCorrienteService.downloadComprobanteRecibo(
        localStorage.clienteId.trim(),
        item.nroRecibo,
      );
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `ADB${localStorage.clienteId.trim()}-${item.nroRecibo}.pdf`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoadingPdf(false);
    } catch (error) {
      setError(true);
      setLoadingPdf(false);
    }
  };

  return (
    <div style={{ margin: "2vw" }}>
      <div className="row">
        <div className="col-10">
          <Filter
            getFilterRecibo={getFilterRecibos}
            filter={filter}
            onSelectedFilter={setFilter}
            clean={clean}
          />
        </div>
        <div className="col-2">
          <Descarga
            loading={loading}
            handleDownload={handleDownload}
          ></Descarga>
        </div>
      </div>
      {error && (
        <Stack sx={{ width: "100%", margin: "2vh" }} spacing={2}>
          <Alert severity="error">No se encuentra el documento.</Alert>
        </Stack>
      )}
      <TableCustom
        page={page}
        onSelectedPage={setPage}
        rowsPerPage={rowsPerPage}
        onSelectedRowPerPage={setRowsPerPage}
        items={props.recibos?.reciboResponses}
        length={props.recibos?.length}
        getItems={getRecibos}
        columns={RECIBO_COLUMN}
        handleDownload={handleDownloadPdf}
        loading={loadingPdf}
        onSort={handleSort}
        sortFields={filter.sortField}
      />
    </div>
  );
};
export default connect(
  (state: any) => ({
    recibos: state.cuentacorriente.recibos,
    error: state.cuentacorriente.error,
    loading: state.cuentacorriente.loading,
  }),
  (dispatch) => ({
    getRecibosByFilter: (filter: IFilterRecibo) =>
      dispatch(getRecibosByFilter(filter)),
  }),
)(Recibo);
